import React from "react";
import { GoogleMap, LoadScript, Marker } from "@react-google-maps/api";

const MapComponent = ({ markers, apiKey, centerMarker = {}}) => {

  if (!apiKey) {
    return (
      <div style={{ color: "Black", textAlign: "center", marginTop: "20px" }}>
        <h2>Google Maps API Key Missing</h2>
        <p>
          Please configure the <strong>GOOGLE_MAPS_API_KEY</strong> in your environment variables.
        </p>
      </div>
    );
  }

  const mapContainerStyle = {
    width: "100%",
    height: "600px",
  };

  // Agrupar marcações por local
  const locationCounts = markers.reduce((acc, marker) => {
    const key = `${marker.position.lat},${marker.position.lng}`;
    acc[key] = (acc[key] || 0) + 1;
    return acc;
  }, {});

  // Encontrar o local com mais marcações
  const mostFrequentLocation = Object.entries(locationCounts).reduce(
    (max, [location, count]) => (count > max.count ? { location, count } : max),
    { location: null, count: 0 }
  );

  // Default to Blockbit HQ location
  const centerMarkGeneral = mostFrequentLocation.location
    ? {
        lat: parseFloat(mostFrequentLocation.location.split(",")[0]),
        lng: parseFloat(mostFrequentLocation.location.split(",")[1]),
      }
    : {
      lat: -23.629906711892616, 
      lng:  -46.70781084232831,
    };
  
  const center = Object.keys(centerMarker || {}).length !== 0 ? centerMarker : centerMarkGeneral;

  return (
    <LoadScript googleMapsApiKey={apiKey}>
      <GoogleMap mapContainerStyle={mapContainerStyle} center={center} zoom={13}>
        {markers.map((marker) => (
          <Marker key={marker.id} position={marker.position} label={marker.title} />
        ))}
      </GoogleMap>
    </LoadScript>
  );
};

export default MapComponent;
